import { Lookup } from '../lookup.interface';
export const ResponseAction: { [name: string]: Lookup } = {
  accepted: { displayValue: 'Accept' },
  rejected: { displayValue: 'Reject' },
};
